import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"

import DatePickerInput from "./DatePickerInput"

const LastDayInput = () => {
  const {
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext()
  const firstDay = watch("first_day")

  const handleLastDayChange = (dateSelection) => {
    setValue("last_day", dateSelection)
    trigger("last_day")
  }

  return (
    <div>
      <Form.Label htmlFor="stw-last-day">Last Day</Form.Label>
      <Controller
        name="last_day"
        render={({ field: { value } }) => (
          <Form.DatePicker
            id="stw-last-day"
            minDate={firstDay}
            hasErrors={Boolean(errors?.last_day)}
            renderCustomHeader={(props) => (
              <Form.DatePicker.QuickNavHeader {...props} />
            )}
            value={value}
            onChange={handleLastDayChange}
            customInput={
              <DatePickerInput
                errorMessage={errors?.last_day ? errors.last_day.message : null}
              />
            }
          />
        )}
      />
    </div>
  )
}

export default LastDayInput
